module.exports = __webpack_public_path__ + "img/合作伙伴.54bf9ddf.png";